import { formatMonthNameYear } from './format';

/**
 * Monatsbeschriftung an einer Kennzahl — `Oct 2026`.
 *
 * 🔴 Bis PR 2 lief das über `date-fns/format(new Date(iso), 'MMM yy')` OHNE
 * Locale: die Form war englisch (`Oct 26`), aber zweistellig im Jahr und ohne
 * Bezug auf die Berliner Zeitzone. `formatMonthNameYear` (NEU-4) liefert die
 * Owner-Form: englische Wörter, vierstelliges Jahr, fester Berliner Tag.
 */
export function formatMonthLabel(monthString) {
  if (!monthString) return '—';
  const iso = monthString.length === 7 ? `${monthString}-01` : monthString;
  return formatMonthNameYear(iso, { placeholder: monthString });
}
